module.exports = __webpack_public_path__ + "static/img/img-honda-beat.721bc75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-honda-beat.png
// module id = /O3O
// module chunks = 36